import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function FullScreenLoader() {
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-background"
      data-testid="auth-loading"
    >
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}

/**
 * Guards a route. Handles three things:
 *  - loading state while we check the session
 *  - redirect to /login when unauthenticated
 *  - forced redirect to /change-password on first login
 *  - role restriction (optional `role` prop)
 */
export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) return <FullScreenLoader />;
  if (user === null) return <Navigate to="/login" replace />;

  // First-login password change is mandatory before anything else — but don't
  // redirect when we're already on the change-password screen (avoids a loop).
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/teacher"} replace />;
  }

  return children;
}
